import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const RouteSpecificMeta = ({ title, description, canonical, SchemaData, image }) => {

  const [isNoindex, setIsnoindex] = useState(false);
  const location = useLocation();
  const originUrl = window.location.origin;

  useEffect(() => {
    // console.log('Url', originUrl );
    // console.log('Title', location.title);
    // console.log('Description', location.description);
    // console.log('Canonical', location.canonical);
    // console.log('Image URL:', image);
    const noindexPaths = [ '/best-hr-software', '/thank-you'];
    const isnoindexPaths = noindexPaths.includes(location.pathname);
    setIsnoindex(isnoindexPaths);

  }, [location.pathname]);


  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {isNoindex && <meta name="robots" content="noindex, nofollow" />}
      {isNoindex && <meta name="googlebot" content="noindex" />}

      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph Meta Tags */}
      <meta property="og:locale" content="en" />
      <meta property="og:site_name" content="qbrbiz" />
      <meta property="og:url" content={originUrl + location.pathname} />
      <meta property="og:type" content="website" />
      <meta property="article:publisher" content="https://www.facebook.com/Qkrbiz/" />
      {/* {image && <meta property="og:image" content={`${window.location.origin}${image}`} />} */}
      {image && <meta property="og:image" content={image.startsWith('http') ? image : `${window.location.origin}${image}`} />}
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

       {/* Twitter Meta Tags */}
       <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@QkrbizDotCom" />
      <meta name="twitter:site" content="@QkrbizDotCom" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* {image && <meta name="twitter:image" content={`${window.location.origin}${image}`} />} */}
      {image && <meta property="twitter:image" content={image.startsWith('http') ? image : `${window.location.origin}${image}`} />}

      {/* JSON-LD Schema */}
      {SchemaData && (
        <script type="application/ld+json">
          {JSON.stringify(SchemaData)}
        </script>
      )}

    </Helmet>
  );
};

export default RouteSpecificMeta;
